import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { EditorModule } from '@progress/kendo-angular-editor';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { MentionModule } from 'angular-mentions';
import { PaginatorModule } from 'primeng/paginator';
import { SkeletonModule } from 'primeng/skeleton';
import { SubmissionApprovalEditorComponent } from './organization/admin/conferences/abstract-management/approval-editor/submission-approval-editor.component';
import { AbstractManagementSubmissionsComponent } from './organization/admin/conferences/abstract-management/submissions/abstract-management-submissions.component';
import { ApplicationPipesModule } from './_shared/modules/application-pipes.module';
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";

@NgModule({
  declarations:[
    SubmissionApprovalEditorComponent,
    AbstractManagementSubmissionsComponent
  ],
  entryComponents:[],
    imports: [
        ApplicationPipesModule,
        InputsModule,
        MentionModule,
        DropDownsModule,
        RouterModule,
        PaginatorModule,
        SkeletonModule,
        CKEditorModule

    ],
  exports:[
    SubmissionApprovalEditorComponent,
    AbstractManagementSubmissionsComponent,
  ]
})
export class SharedOrgAdminConferenceCMSModule{}
